import { UseQueryResult, useQuery } from 'react-query';
import { api } from '../api';
import { Firm } from '../types/firm';
import { firmHexColourCache } from './cache';

export type GetUserFirmsReponse = {
    firms: Firm[];
};

export function generateAvatarColour(data: GetUserFirmsReponse): GetUserFirmsReponse {
    function genColour(id: string): string {
        if (firmHexColourCache[id]) {
            return firmHexColourCache[id];
        }
        const colours = ['#3b82f6', '#22c55e', '#ef4444', '#eab308', '#a855f7', '#14b8a6'];
        const profileHexColour = colours[Math.floor(Math.random() * colours.length)];
        firmHexColourCache[id] = profileHexColour;

        return profileHexColour;
    }

    return {
        firms: data.firms.map((f) => {
            return { ...f, avatarHexColour: genColour(f.id) };
        }),
    };
}

async function getUserFirms(id: string): Promise<GetUserFirmsReponse> {
    const { data } = await api.get(`/profile/firms`);
    return data;
}

export function useUserFirms(id: string): UseQueryResult<GetUserFirmsReponse, unknown> {
    return useQuery(['user-firms', id], () => getUserFirms(id), {
        keepPreviousData: true,
        select: generateAvatarColour,
    });
}
